import React, { useState } from 'react';
import {  useLocation } from 'react-router-dom';
import { useJWTAuthActions } from "../../services/JWTAuthProvider";

export const Login = () => {
    const { signInUser } = useJWTAuthActions();
    const location = useLocation();
    const { username: usernameFromState } = location.state || { username: '' };
    const [username, setUsername] = useState(usernameFromState);
    const [password, setPassword] = useState('');
    const [usernameError, setUsernameError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const navigateToReset = async () => {
        if (!username || !password) {
            if (!username) setUsernameError(true);
            if (!password) setPasswordError(true);
        } else {
            await signInUser({ email: username, password });
        }
    };

    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
        setUsernameError(false);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setPasswordError(false);
    };

    return (
        <div className="main1">
            <div className="left-part"></div>
            <div className="right-part">
                <div className="right-top">
                    <img src="/Assets/logo.svg" alt="Resource Center" />
                    <h2>Login Credential</h2>
                </div>
                <form className="login-input">
                    <label className="form-label">Username or Email ID</label>
                    <div className={`input-wrap ${usernameError ? 'error' : ''}`}>
                        <input
                            type="text"
                            className={`form-control user-input ${usernameError ? 'error-border' : ''}`}
                            value={username}
                            onChange={handleUsernameChange}
                        />

                        <div className="input-img">
                            <img src="/Assets/user.svg" alt="User" />
                        </div>
                    </div>
                    {usernameError && <p className="error-message">* Username is required</p>}

                    <label className="form-label">Password</label>
                    <div className={`input-wrap ${passwordError ? 'error' : ''}`}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className={`form-control ${passwordError ? 'error-border' : ''}`}
                            value={password}
                            onChange={handlePasswordChange}
                        />

                        <div className={`input-img ${showPassword ? 'show-pass' : 'hide-pass'}`} onClick={togglePasswordVisibility}>
                        </div>
                    </div>
                    {passwordError && <p className="error-message">* Password is required</p>}

                    <div className="login-btn">
                        <button className="btn-primary" type="button" onClick={navigateToReset}>
                            Sign in
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};